<template>
  <div>
    <div v-if="this.pending" class="row">
      <loading></loading>
    </div>
    <div v-else class="row">
      <div class="col-3">
        <listeEspace
          style="overflow-y: auto;"
          :tableau-data="this.data"
        ></listeEspace>
      </div>
      <div class="col-9">
        <loading v-if="this.loading && !this.ficheData"></loading>
        <ficheEspaceContent
          style="height: calc(100vh - 100px); overflow-y: auto;"
          v-else-if="!this.loading && this.ficheData"
          :fiche="this.ficheData"
        ></ficheEspaceContent>
      </div>
    </div>
  </div>
</template>

<script>
import listeEspace from '../../components/ficheEspace/listeEspace'
import ficheEspaceContent from '../../components/ficheEspace/ficheEspaceContent'
import { mapActions, mapGetters } from 'vuex'
import loading from '../../components/loading'

export default {
  components: {
    listeEspace,
    ficheEspaceContent,
    loading
  },
  data () {
    return {
      data: null,
      ficheData: null
    }
  },
  methods: {
    ...mapActions(['setLinkComment', 'setIsFromNotif', 'setIsLoadedComments', 'setEntityId', 'setTypeModule', 'getListOnglet', 'getTableauSurface', 'getAllDataTableauSurface', 'loadFiche', 'setCurrentProject', 'getFicheTableauData', 'setLoading', 'setPending', 'setCurrentFiche', 'setLastFiche']),
    ...mapGetters(['currentLigne', 'projectId', 'tableauSurfaceList', 'isLoadingTableauData', 'isFicheLoaded', 'getFiche', 'isLoadingFicheData', 'currentFicheData'])
  },
  computed: {
    ...mapGetters(['tableauData', 'currentFiche', 'currentProject', 'loading', 'ficheTableauData', 'pending', 'notifLink', 'isFromNotif', 'lastFiche'])
  },
  watch: {
    ficheTableauData: {
      handler (newValue) {
        this.data = [...newValue]
      },
      deep: true
    },
    async currentFiche (newValue, oldValue) {
      if (newValue != null) {
        try {
          this.setLoading(true)
          this.ficheData = null
          await this.loadFiche({ficheId: newValue, ligne: this.currentLigne()})
          this.ficheData = this.currentFicheData()
        } catch (e) {
        } finally {
          this.setLoading(false)
        }
      }
    },
    async notifLink (newValue) {
      if (newValue.entite !== this.currentFiche) {
        this.setPending(true)
        this.setIsLoadedComments(false)
        this.setEntityId(newValue.entite)
        await this.getFicheTableauData(newValue.projet.id)
        this.setCurrentFiche(newValue.entite)
        this.setLinkComment(null)
        this.setPending(false)
      }
      this.setIsFromNotif(true)
    }
  },
  async created () {
    this.setTypeModule('fiche_espace')
    const idProject = this.$route.params.idProject
    if (this.currentProject == null || (idProject + '' !== this.currentProject + '')) {
      this.setCurrentProject(idProject)
    }

    this.setPending(true)
    await this.getFicheTableauData(this.currentProject)
    this.setCurrentFiche(null)
    if (this.notifLink) {
      this.setCurrentFiche(this.notifLink.entite)
      this.setEntityId(this.notifLink.entite)
      this.setLinkComment(null)
      this.setPending(false)
      return
    }
    if (this.lastFiche != null) {
      this.setCurrentFiche(this.lastFiche)
      this.setLastFiche(null)
    }
    this.setPending(false)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pageFicheEspace/index.vue